import { useCallback } from "react";
import { Navigate, useParams, useSearchParams } from "react-router-dom";
import { useTranslations } from "next-intl";
import { MessagesInbox } from "@/components/messages-inbox";
import { useAuthStore } from "@/stores/authStore";

export function TenantMessagesPage() {
  const { tenantSlug = "" } = useParams<{ tenantSlug: string }>();
  const t = useTranslations("messaging");
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  // COMM-5: `?with=<userId>` (from a "New message from …" notification) opens that conversation.
  const [searchParams, setSearchParams] = useSearchParams();
  const withUserId = searchParams.get("with");
  const handleSelect = useCallback(
    (userId: string) => setSearchParams({ with: userId }, { replace: true }),
    [setSearchParams],
  );

  if (!isAuthenticated) {
    return <Navigate to={`/t/${tenantSlug}/login`} replace />;
  }

  return (
    <main className="mx-auto max-w-4xl px-4 py-10">
      <h1 className="text-2xl font-semibold">{t("title")}</h1>
      <p className="mt-1 text-sm text-[var(--text-muted)]">{t("subtitle")}</p>
      <div className="mt-6">
        <MessagesInbox initialContactId={withUserId} onSelectContact={handleSelect} />
      </div>
    </main>
  );
}
